import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { ReferrerDetailInfo } from '../../models/referralModel';

interface Props {
  referrer: ReferrerDetailInfo;
}

const ReferrerHeaderCard: React.FC<Props> = ({ referrer }) => {
  const firstName = referrer.first_name || '';
  const lastName = referrer.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim() || 'Sin nombre';

  const initials =
    `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'R';

  const phone = referrer.phone
    ? `${referrer.phone_area_code || '+503'} ${referrer.phone}`
    : 'Sin teléfono';
  const email = referrer.email || 'Sin correo';
  const dui = referrer.dui ? `DUI ${referrer.dui}` : null;
  const bankInfo =
    referrer.bank_name || referrer.account_number
      ? `Cuenta ${referrer.bank_name || ''} — ${referrer.account_number || ''}`.trim()
      : null;

  return (
    <Card
      className="shadow-sm border-0 mb-4"
      style={{
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.06)',
        backgroundColor: '#ffffff',
      }}
    >
      <CardBody className="py-3 px-4">
        <Row className="align-items-center">
          {/* Avatar con iniciales */}
          <Col className="col-auto pr-0">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center text-white font-weight-bold shadow-sm"
              style={{
                width: '44px',
                height: '44px',
                backgroundColor: '#00c389',
                fontSize: '15px',
                letterSpacing: '0.5px',
              }}
            >
              {initials}
            </div>
          </Col>

          {/* Nombre y Estadísticas */}
          <div className="col pl-3">
            <div className="d-flex align-items-center flex-wrap">
              <h3
                className="font-weight-bold text-dark mb-0 mr-3"
                style={{ fontSize: '17px' }}
              >
                {fullName}
              </h3>

              <div
                className="d-flex align-items-center text-muted font-weight-500"
                style={{ fontSize: '13px' }}
              >
                <span className="font-weight-bold text-dark mr-1">
                  {referrer.total_referrals || 0}
                </span>{' '}
                Referidos
                <span className="mx-2 text-gray">·</span>
                <span className="font-weight-bold text-dark mr-1">
                  {referrer.total_paid || 0}
                </span>{' '}
                Pagados
              </div>
            </div>

            {/* Metadatos secundarios: Teléfono, Email, DUI, Cuenta Bancaria */}
            <div
              className="d-flex align-items-center flex-wrap text-muted mt-1"
              style={{ fontSize: '12px' }}
            >
              <span>{phone}</span>
              <span className="mx-2 text-gray">·</span>
              <span>{email}</span>
              {dui && (
                <>
                  <span className="mx-2 text-gray">·</span>
                  <span>{dui}</span>
                </>
              )}
              {bankInfo && (
                <>
                  <span className="mx-2 text-gray">·</span>
                  <span>{bankInfo}</span>
                </>
              )}
            </div>
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ReferrerHeaderCard;
